/**
 * Which card reader this till sends card payments to (`payments.terminal`),
 * remembered on the device. Null when none is chosen, the plan has no
 * readers, or the chosen one has been retired at this site.
 */

import { useState } from 'react';
import {
  readerForThisTill,
  setReaderForThisTill,
  useCardReaders,
  useEntitlements,
  usePractice,
} from '@restaurant/api-client';

/** The reader this till uses, if it still exists at this site. */
export function useTillReader(locationId: string | undefined) {
  const entitlements = useEntitlements();
  const entitled = entitlements.has('payments.terminal');
  const readers = useCardReaders(locationId, { enabled: entitled });
  const [chosen, setChosen] = useState<string | null>(readerForThisTill);
  const live = readers.data ?? [];
  // Practice never asks the card machine: a card is typed in, and nothing is
  // charged (`practice.tsx`).
  const practising = usePractice().practising;
  const reader = entitled && !practising ? (live.find((r) => r.id === chosen) ?? null) : null;

  return {
    entitled,
    readers: live,
    reader,
    choose: (id: string | null) => {
      setReaderForThisTill(id);
      setChosen(id);
    },
  };
}
